import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './Footer.module.css';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
        <div className={styles.footerGrid}>
          <div className={styles.brand}>
            <div className={styles.brandLogo}>
              <img src="/logolarge.png" alt="OFMIG.SHOP" className={styles.brandLogoImg} />
            </div>
            <p className={styles.brandDesc}>
              {t('footer.description')}
            </p>
          </div>

          <div className={styles.footerCol}>
            <h4>{t('footer.quickLinks')}</h4>
            <ul>
              <li><Link to="/">{t('nav.home')}</Link></li>
              <li><Link to="/#pricing">{t('nav.pricing')}</Link></li>
              <li><Link to="/#faq">{t('nav.faq')}</Link></li>
            </ul>
          </div>

          <div className={styles.footerCol}>
            <h4>{t('footer.legalLinks')}</h4>
            <ul>
              <li><Link to="/terms">{t('footer.terms')}</Link></li>
            </ul>
          </div>
        </div>

        <div className={styles.footerBottom}>
          <p className={styles.copyright}>
&copy; {new Date().getFullYear()} OFMIG.SHOP. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
